var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/brand.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/urls.j2", false, "product/templates/product-meta/brand.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("brandsUrl")) {
var t_4 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_4);
output += "\n\n\n<p class=\"c-product-meta__brand\" data-qa-product-brand>\n\n    <a ";
output += runtime.suppressValue((lineno = 6, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","product brand click",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productMeta")),"brand")])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 6, colno = 83, runtime.callWrap(t_4, "brandsUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productMeta")),"brandSlug")])), env.opts.autoescape);
output += "\" class=\"c-product-meta__a c-product-meta__brand-link\" data-qa-brand-link>\n\n        ";
output += runtime.suppressValue((lineno = 8, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_shop-all-brand",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productMeta")),"brand")]})])), env.opts.autoescape);
output += "\n\n    </a>\n\n</p>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/brand.j2"] , dependencies)